import { Pipe } from '@angular/core';
import { ColOrColGroupDef } from '@bo-client/shared/entity-list-page/entity-list-page.component';
import { ColDef, ColGroupDef, DateFilterParams } from 'ag-grid-community';

@Pipe({
  name: 'entityListPageColumnDefinitions'
})
export class EntityListPageColumnDefinitionsPipe {
  transform(colDefs: ColOrColGroupDef[]): ColOrColGroupDef[] {
    if (!colDefs) {
      return [];
    }
    const defaultColDef: ColOrColGroupDef = {
      resizable: true,
      sortable: true,
      floatingFilter: true,
      filter: 'agTextColumnFilter',
      useValueFormatterForExport: true
    };

    return colDefs.map((colDef) => {
      if ((colDef as ColGroupDef).children) {
        return {
          ...colDef,
          children: this.transform((colDef as ColGroupDef).children)
        };
      }
      return {
        ...defaultColDef,
        ...colDef,
        filterParams:
          (colDef as ColDef).filter === 'agDateColumnFilter'
            ? ({ maxNumConditions: 1, ...(colDef as ColDef).filterParams } as DateFilterParams)
            : (colDef as ColDef).filterParams
      };
    });
  }
}
